const isEnabled = (value: string | undefined): boolean => value === 'true';

export const isReportingPaused = (): boolean => isEnabled(import.meta.env.VITE_REPORTING_PAUSED);
export const isTeamsIntegrationEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_TEAMS_INTEGRATION === 'true';

/** When true, Apply navigates to the Contract Management Application Process Portal instead of the legacy DTI iframe. */
export const isContractAppProcessEnabled = (): boolean =>
  import.meta.env.VITE_FSL_CONTRACT_APP_PROCESS_ENABLE === 'true';

export const getContractAppProcessUrl = (): string | undefined => {
  const url = import.meta.env.VITE_FSL_CONTRACT_APP_PROCESS_URL;
  return typeof url === 'string' && url.trim() !== '' ? url.trim() : undefined;
};
isEnabled(import.meta.env.VITE_ENABLE_TEAMS_INTEGRATION);

/**
 * Master switch for Admin Tools. Every individual admin tool is additionally
 * gated by its own flag, so an environment can expose a subset of the tools.
 * All flags are opt-in: an unset flag means the tool is unavailable.
 */
export const isAdminToolsEnabled = (): boolean =>
  isEnabled(import.meta.env.VITE_ENABLE_ADMIN_TOOLS);

const isAdminToolEnabled = (value: string | undefined): boolean =>
  isAdminToolsEnabled() && isEnabled(value);

export const isAdminShelterSwitcherEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_SHELTER_SWITCHER);

export const isAdminManagementEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_MANAGEMENT);

export const isAdminShelterManagementEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_SHELTER_MANAGEMENT);

export const isAdminDateOverrideEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_DATE_OVERRIDE);

export const isAdminJoinDateOverrideEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_JOIN_DATE_OVERRIDE);

export const isAdminSentryDiagnosticsEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_SENTRY_DIAGNOSTICS);

export const isAdminDatabaseToolsEnabled = (): boolean =>
  isAdminToolEnabled(import.meta.env.VITE_ENABLE_ADMIN_DATABASE_TOOLS);

export const isAnyAdminToolEnabled = (): boolean =>
  isAdminShelterSwitcherEnabled() ||
  isAdminManagementEnabled() ||
  isAdminShelterManagementEnabled() ||
  isAdminDateOverrideEnabled() ||
  isAdminJoinDateOverrideEnabled() ||
  isAdminSentryDiagnosticsEnabled() ||
  isAdminDatabaseToolsEnabled();
